<!--情景定义--旧的--原则上-->
<template>
	<treeBody>
		<listView slot="tree" :dataList='sceneList' @checkItem="nowScene = $event" :autoCheckIndex='0'></listView>
		<div slot="body">
			<div class="buttonLine">
				<iconButton icoName="wedoButton/add.png" buttonText="添加情景" @buttonClick="addScene"></iconButton>
				<iconButton icoName="wedoButton/delete.png" buttonText="删除情景" @buttonClick="deleteScene"></iconButton>
				<iconButton icoName="wedoButton/add.png" buttonText="添加设备" @buttonClick="addDevice" v-if="nowScene != undefined"></iconButton>
				<iconButton icoName="wedoButton/delete.png" buttonText="删除设备" @buttonClick="deleteDevice" v-if="nowScene != undefined"></iconButton>
				<span> 通讯间隔(毫秒) ：</span>
				<input type="number" v-model="nowScene.interval" v-if="nowScene != undefined">
				<iconButton icoName="wedoButton/confirm.png" buttonText="提交保存" @buttonClick="updateScene"></iconButton>
			</div>
			<infoList ref="deviceList" style="height: calc(100% - 0.47rem)" :columns='columns' :dataList="nowDeviceList"
			 :pageLen='nowDeviceList.length < 20 ? 20 : nowDeviceList.length' :totalSize="nowDeviceList.length" :fillAll="true"
			 :showIndex="false" @checkItem="nowDevice = $event" @dblclick="dblClick"></infoList>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import listView from '@/components/module/selection/base/listView.vue'

	export default {
		components: {
			treeBody,
			iconButton,
			infoList,
			listView
		},
		props: {},
		data() {
			return {
				sceneList: [],
				nowScene: undefined,
				sceneIdToDeviceList: {},
				columns: [{
					name: '设备名称',
					key: 'name',
					getTdStyleMethod(item, index) {
						return {
							'text-align': 'left'
						}
					}
				}, {
					name: '遥控指令(双击切换)',
					key: 'command',
					getTdStyleMethod(item, index) {
						return {
							cursor: 'pointer'
						}
					}
				}],
				nowDevice: undefined,
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.getSceneTree()
		},
		destroyed() {},
		computed: {
			nowDeviceList() {
				if (this.nowScene == undefined) {
					return []
				}
				return getValueIfNoNull(this.sceneIdToDeviceList[this.nowScene.id], [])
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			nowUnitVirtualDeviceTree() {
				return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(this.nowUnit.id)
			},
			nowUnitVirtualDeviceTreeList() {
				return treeToList(this.nowUnitVirtualDeviceTree, 'next', item => !isempty(item.next)).filter(item => item.entityName ==
					"VirtualDevicePojo")
			},
			nowCheckIdList() {
				//当前情景下哪些设备是已经被选中的，如果是选中的，设备名字就一样，只认名字，因为没有设备no
				var idList = []
				var deviceIdList = this.nowDeviceList.map(item => item.id)
				var deviceList = this.nowUnitVirtualDeviceTreeList.filter(item => deviceIdList.includes(item.id))
				return deviceList.map(item => item.no)
			}
		},
		watch: {
			nowCheckIdList(nv, ov) {

			},
			nowScene(nv, ov) {
				if (ov != undefined && ov.id != nv.id) {
					this.$set(this.sceneIdToDeviceList, ov.id, ov.next)
				}
			}
		},
		methods: {
			getSceneTree() {
				this.$api.lightOldApi.getLightSceneTree(respon => {
					//移除里面的时控
					respon = respon.filter(item => item.sceneType == 0)
					for (var i = 0, len = respon.length; i < len; i++) {
						if (respon[i].interval == undefined) {
							respon[i].interval = 2000
						}
						var next = respon[i].next
						for (var i1 = 0, len1 = next.length; i1 < len1; i1++) {
							var item = next[i1]
							//获取他的指令
							if (item.hasOwnProperty('next') && item.next[0] != undefined) {
								item.command = item.next[0].percent == 1 ? '开' : '关'
							} else {
								item.command = '无效'
							}
						}
						this.$set(this.sceneIdToDeviceList, respon[i].id, next)
					}
					if (respon.length > 0) {
						if (this.nowScene == undefined) {
							this.nowScene = respon[0]
						} else {
							var target = respon.find(item => item.id == this.nowScene.id),
								undefined
							if (target != undefined) {
								this.nowScene = copy(target)
							} else {
								this.nowScene = undefined
							}
						}
					} else {
						this.nowScene = undefined
					}
					this.sceneList = respon
				})
			},
			addScene() {
				this.$dialogMethod.openNomalInputDialog('创建情景', [{
					name: '情景名称',
					type: 0,
					pkid: 'name'
				}, {
					name: '通讯间隔',
					type: 3,
					pkid: "interval",
					defaultValue: 2000
				}], respon => {
					this.$api.lightOldApi.saveScene(undefined, respon.name, getValueIfNoNull(this.sceneList[this.sceneList.length -
						1], {
						serialnum: 0
					}).serialnum + 1, respon.interval, respon => {
						this.$dialogMethod.showMessage('添加成功!')
						this.getSceneTree()
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			deleteScene() {
				if (this.nowScene == undefined) {
					this.$dialogMethod.showMessage('请先选中一个情景!')
					return
				}
				this.$dialogMethod.openAgreeDialog('删除情景', '确定要删除情景【' + this.nowScene.name + '】吗?', respon => {
					this.$api.lightOldApi.deleteScene(this.nowScene.id, respon => {
						this.$dialogMethod.showMessage('删除成功!')
						this.getSceneTree()
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			addDevice() {
				//绑定虚拟设备
				this.$dialogMethod.getMultipleSelectionDialog().setGetIdMethod(item => item.entityName == "VirtualDevicePojo" ?
					item.id : 'group' +
					item.id)
				this.$dialogMethod.openMultipleSelectionDialog('选择虚拟设备', this.nowUnitVirtualDeviceTree.next, this.nowCheckIdList,
					respon => {
						respon = respon.filter(item => item.entityName == "VirtualDevicePojo")
						//idMap
						var idMap = {}
						for (var i = 0, len = this.nowDeviceList.length; i < len; i++) {
							var item = this.nowDeviceList[i]
							idMap[item.id] = item
						}
						//为已存在的设备添加数据
						respon = respon.map(item => {
							if (idMap[item.id] != undefined) {
								return idMap[item.id]
							}
							return item
						})
						for (var i = 0, len = respon.length; i < len; i++) {
							//默认是开
							var item = respon[i]
							if (item.entityName == "VirtualDevicePojo" && !item.hasOwnProperty('command')) {
								item.command = '开'
							}
						}
						//添加设备，但是先不提交
						this.$set(this.sceneIdToDeviceList, this.nowScene.id, respon)
					})
			},
			deleteDevice() {
				if (this.nowDevice == undefined) {
					this.$dialogMethod.showMessage('请先选中一个设备!')
					return
				}
				//删除但是不提交
				var tempId = this.nowDevice.id
				var list = this.sceneIdToDeviceList[this.nowScene.id]
				list = list.filter(item => {
					return item.id != tempId
				})
				this.$set(this.sceneIdToDeviceList, this.nowScene.id, list)
			},
			updateScene() {
				//提交当前的通讯间隔
				this.$api.lightOldApi.saveScene(this.nowScene.id, this.nowScene.name, this.nowScene.serialnum, this.nowScene.interval,
					respon => {
						this.$dialogMethod.showMessage('通讯间隔提交成功!')
					})
				//提交设备列表
				var deviceIdList = this.nowDeviceList.map(item => item.id)
				var needRemoveList = []
				var commandList = this.nowDeviceList.map(item => {
					if (item.command == '无效') {
						return undefined
					}
					return item.command == '开' ? 1 : 0
				}).filter((item, index) => {
					//移除无效的设备
					if (item == undefined) {
						needRemoveList.push(index)
						return false
					}
					return true
				})
				deviceIdList = deviceIdList.filter((item, index) => {
					return !needRemoveList.includes(index)
				})
				//先删所有设备再添加
				var saveCallback = respon => {
					this.$dialogMethod.showMessage('设备提交成功!')
					this.getSceneTree()
				}
				var deleteCallback = respon => {
					if (!isempty(deviceIdList)) {
						this.$api.lightOldApi.saveDevice(this.nowScene.id, deviceIdList.join(','), commandList.join(','), saveCallback,
							saveCallback)
					} else {
						saveCallback()
					}
				}
				if (!isempty(this.nowScene.next.map(item => item.id).join(','))) {
					this.$api.lightOldApi.deleteDevice(this.nowScene.id, this.nowScene.next.map(item => item.id).join(','),
						deleteCallback,
						deleteCallback)
				} else {
					deleteCallback()
				}
			},
			dblClick(item) {
				if (item) {
					if (item.command == '无效') {
						this.$dialogMethod.showMessage('无效的设备')
						return
					}
					this.$set(item, 'command', item.command == '开' ? '关' : '开')
					this.$refs.deviceList.nowCheckIndex = -1
				}
			}
		}
	}
</script>

<style scoped>
	>>>ul.list-body>li.isCheck {
		color: #5273C3 !important;
	}
</style>
